
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from '../redux/store';
import { AuthStatus, LocalStorageKey, LoginType } from '../types';
import { readLocalStorage, saveLocalStorage } from '../toolbox/helpers/local-storage-helpers';
import { onChangeAuthStatus, onLogin, onLogout, onRefreshToken, onSetCount, onSetVisibleBadge, onVerifying } from '../redux/slices/authSlice';
import { AuthAPI } from '../apis/AuthAPI';
import { ProfileAPI } from '../apis/ProfileAPI';
import { CustomSnackbar } from '../components/common/CustomSnackbar/CustomSnackbar';
import { unmaskRUT } from '../toolbox/helpers/rut-helper';
// import Echo from 'laravel-echo'
// import Pusher from 'pusher-js'

export const useAuthStore = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  // const _ = [Pusher]
  const { status, user, errorMessage } = useSelector(state => state.authSlice)

  const setProfileData = async (access_token: string, datauser = '') => {
    try {
      const perfil = await ProfileAPI.me(access_token, datauser);
      const { detail } = perfil;
      saveLocalStorage(LocalStorageKey.USER_DATA, detail);
      dispatch(onLogin(detail));
      // connectPusher(detail?.id, `${access_token}`)
      dispatch(onSetCount(detail?.countN || 0))
      dispatch(onSetVisibleBadge(detail?.countN > 0 ? true : false))
      return detail;
    } catch (error) {
      console.error(error);
    }
  }

  const login = async ({ username, rut_company, password, iduser_type }: LoginType) => {
    try {
      const login = await AuthAPI.login(username, rut_company, password, iduser_type);
      if (!login?.detail?.access_token) return CustomSnackbar('error', login.data.message || "")

      const { access_token, user } = login.detail
      saveLocalStorage(LocalStorageKey.TOKEN_KYTE, access_token)
      if (rut_company) {
        saveLocalStorage(LocalStorageKey.SESSION_COMPANY_RUT, unmaskRUT(String(rut_company).trim()))
      }
      const detail = await setProfileData(access_token, user)

      CustomSnackbar('success', "Bienvenido")

      return {
        status: true,
        detail
      }

    } catch (error) {
      dispatch(onLogout('Credenciales Incorrectas'))
      CustomSnackbar('error', 'Credenciales Incorrectas');
      return {
        status: false,
        detail: {}
      }
    }
  }

  const verifySession = async () => {
    dispatch(onVerifying());
    const token = readLocalStorage(LocalStorageKey.TOKEN_KYTE);
    if (!token) return dispatch(onLogout());
    try {
      if (token) {
        const userData = readLocalStorage(LocalStorageKey.USER_DATA)
        const detail = await setProfileData(token, userData)
        dispatch(onChangeAuthStatus(AuthStatus.AUTHENTICATED));
        navigate({ pathname: location.pathname })
        return
      }/* else{
          await refreshToken(token)
        } */
      localStorage.clear();
      dispatch(onLogout());
      CustomSnackbar('error', 'Su sesión expiró');
    } catch (error) {
      CustomSnackbar('error', 'Su sesión expiró');
      localStorage.clear();
      dispatch(onLogout());
    }
  }

  const refreshToken = async (token: string) => {
    try {
      const session = await AuthAPI.refresh(token);
      if (!session?.detail?.token) {
        localStorage.clear();
        dispatch(onLogout());
        CustomSnackbar('error', 'Su sesión expiró');
      } else {
        const { token, user } = session.detail
        await setProfileData(token.access_token)
        saveLocalStorage(LocalStorageKey.TOKEN_KYTE, token.access_token)
        dispatch(onRefreshToken(user))

        navigate({ pathname: location.pathname })
      }
    } catch (error) {
      console.error('[Error whilte refreshing token]', error)
    }
  }

  const logout = async () => {
    const logout = await AuthAPI.logout();
    const { detail } = logout;
    CustomSnackbar('success', detail || 'Sesión cerrada con éxito');
    localStorage.clear();
    dispatch(onLogout());
  }


  // const connectPusher = (UserId, token) => {
  //   if (UserId) {
  //     window['Echo'] = new Echo({
  //       broadcaster: 'pusher',
  //       key: 'facturador_key',
  //       wsHost: window.location.hostname,
  //       wsPort: 6006,
  //       cluster: 'mt1',
  //       // wssPort: 6001,
  //       disableStats: true,
  //       forceTLS: false,
  //       encrypted: false,
  //       enabledTransports: ['ws', 'wss'],
  //       authEndpoint: 'https://www.facturador.factories.cl/api/broadcasting/auth',
  //       // authEndpoint: 'http://localhost:8000/api/broadcasting/auth',
  //       // authEndpoint: `${process.env.REACT_APP_HOST}/api/broadcasting/auth`,
  //       auth: {
  //         headers: {
  //           'Access-Control-Allow-Origin': '*',
  //           Accept: 'application/json',
  //           Authorization: `Bearer ${token}`
  //         }
  //       },
  //     })
  //     window['Echo'].private(`notification${UserId}`).listen('NotificationEvent', (e) => {
  //       console.log(e)
  //       console.log('company')
  //       const { count = 0 } = e?.data;
  //       if (count > 0) {
  //         dispatch(onSetVisibleBadge(true))
  //         dispatch(onSetCount(count))
  //       }

  //     })
  //   }
  // }

  return {
    /* states */
    status,
    user,
    errorMessage,
    /* actions */
    login,
    logout,
    verifySession,
    setProfileData
  }
}